export const LOCALSTORAGE_TEMPLATE_CREATE_KEY = "createFromTemplateKey";
